'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

var _homepageHero = require('../../homepage-hero');

var _homepageHero2 = _interopRequireDefault(_homepageHero);

var _themeManager = require('../../../../utilities/themeManager');

var _themeManager2 = _interopRequireDefault(_themeManager);

var _default = require('../props/default');

var _default2 = _interopRequireDefault(_default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var ORGANISM_NAME = 'overlay-hero';

var OverlayHero = function (_HomepageHero) {
  _inherits(OverlayHero, _HomepageHero);

  function OverlayHero(props) {
    _classCallCheck(this, OverlayHero);

    var _this = _possibleConstructorReturn(this, (OverlayHero.__proto__ || Object.getPrototypeOf(OverlayHero)).call(this, props));

    _this.state = {
      showOverlay: false
    };

    _this.toggleOverlay = _this.toggleOverlay.bind(_this);
    _this.renderOverlay = _this.renderOverlay.bind(_this);
    return _this;
  }

  _createClass(OverlayHero, [{
    key: 'toggleOverlay',
    value: function toggleOverlay() {
      var _this2 = this;

      if (this.state.showOverlay) {
        document.getElementById('overlay-hero__overlay').classList.add('close');
        window.setTimeout(function () {
          _this2.setState({
            showOverlay: !_this2.state.showOverlay
          });
        }, 500);
      } else {
        this.setState({
          showOverlay: !this.state.showOverlay
        }, function () {
          window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        });
      }
    }
  }, {
    key: 'renderOverlay',
    value: function renderOverlay(theme) {
      var overlayTheme = theme || 'theme-background-color-dark';

      return _react2.default.createElement(
        'div',
        {
          id: ORGANISM_NAME + '__overlay',
          className: ORGANISM_NAME + '__overlay ' + overlayTheme
        },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-lg-12 col-xs-12' },
              _react2.default.createElement('button', {
                className: ORGANISM_NAME + '__ribbon__btn close',
                'data-pa-click': ORGANISM_NAME + '|ribbon-close',
                onClick: this.toggleOverlay
              }),
              this.props.children
            )
          )
        )
      );
    }
  }, {
    key: 'renderRibbon',
    value: function renderRibbon(ribbon) {
      var config = ribbon.config,
          img = ribbon.img,
          text = ribbon.text;


      config.theme = config.theme || 'theme-background-color-dark';

      if (text) {
        return (
          /* eslint-disable-next-line */
          _react2.default.createElement(
            'div',
            {
              className: ORGANISM_NAME + '__ribbon ' + config.theme,
              'data-pa-click': ORGANISM_NAME + '|ribbon-container',
              onClick: this.toggleOverlay
            },
            _react2.default.createElement(
              'div',
              { className: 'container' },
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-lg-10 col-xs-10' },
                  img && img.src ? _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                      'div',
                      { className: 'col-lg-2 col-xs-2' },
                      _react2.default.createElement('img', { className: ORGANISM_NAME + '__ribbon__img', src: img.src, alt: img.alt })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'col-lg-10 col-xs-10' },
                      _react2.default.createElement(
                        _heading2.default,
                        { level: 2 },
                        htmlToReactParser.parse(text)
                      )
                    )
                  ) : _react2.default.createElement(
                    _heading2.default,
                    { level: 2 },
                    htmlToReactParser.parse(text)
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'col-lg-2 col-xs-2'
                  },
                  _react2.default.createElement('button', {
                    className: ORGANISM_NAME + '__ribbon__btn open',
                    'data-pa-click': ORGANISM_NAME + '|ribbon-open',
                    onClick: this.toggleOverlay
                  })
                )
              )
            )
          )
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var showOverlay = this.state.showOverlay;

      var theme = this.props.config.theme || 'theme-background-image-dark';
      var newProps = (0, _themeManager2.default)({ content: this.props.content }, theme);
      var content = newProps.content;
      var _props = this.props,
          config = _props.config,
          className = _props.className,
          viewport = _props.viewport;
      var headline = content.headline,
          paragraph = content.paragraph,
          mediaButton = content.mediaButton,
          primaryCta = content.primaryCta,
          secondaryCta = content.secondaryCta,
          hatchText = content.hatchText,
          ribbon = content.ribbon;


      var sectionClasses = (0, _classnames2.default)(ORGANISM_NAME + '-organism', 'home-hero-organism', className);

      var heroClasses = (0, _classnames2.default)(ORGANISM_NAME, 'home-hero', config.height || 'tall', theme);

      var backgroundImage = config.backgroundImage && (config.backgroundImage[viewport] || config.backgroundImage.url);
      var backgroundPosition = config.backgroundImage && config.backgroundPosition;
      var backgroundImageStyle = backgroundImage ? {
        backgroundImage: 'url(' + backgroundImage + ')',
        backgroundPosition: '' + (backgroundPosition || 'center')
      } : null;

      return _react2.default.createElement(
        'section',
        {
          ref: function ref(c) {
            _this3.organismRef = c;
          },
          id: config.id ? config.id : null,
          className: sectionClasses,
          'data-building-block': 'organism'
        },
        _react2.default.createElement(
          'div',
          { className: heroClasses, style: backgroundImageStyle },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: this.getAlignment(config.textAlign) },
                _react2.default.createElement(
                  'div',
                  null,
                  this.renderHeadline(headline),
                  this.renderParagraph(paragraph),
                  this.renderMediaButton(mediaButton),
                  this.renderCta(primaryCta),
                  this.renderCta(secondaryCta),
                  this.renderHatchText(hatchText)
                )
              )
            )
          )
        ),
        showOverlay ? this.renderOverlay(ribbon.config.theme) : this.renderRibbon(ribbon)
      );
    }
  }]);

  return OverlayHero;
}(_homepageHero2.default);

exports.default = OverlayHero;


OverlayHero.propTypes = {
  viewport: _propTypes2.default.string,
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    backgroundImage: _propTypes2.default.shape({
      url: _propTypes2.default.string.isRequired,
      portable: _propTypes2.default.string.isRequired,
      mobile: _propTypes2.default.string.isRequired
    }).isRequired,
    theme: _propTypes2.default.oneOf(['theme-background-image-dark', 'theme-background-image-light']),
    height: _propTypes2.default.oneOf(['short', 'tall']),
    backgroundPosition: _propTypes2.default.oneOf(['left', 'center', 'right']),
    textAlign: _propTypes2.default.oneOf(['center', 'left']).isRequired
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    mediaButton: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired,
      'data-video-id': _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string,
      id: _propTypes2.default.string
    }),
    primaryCta: _propTypes2.default.shape({
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      id: _propTypes2.default.string,
      fpti: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }).isRequired,
    secondaryCta: _propTypes2.default.shape({
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      id: _propTypes2.default.string,
      fpti: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    ribbon: _propTypes2.default.shape({
      config: _propTypes2.default.shape({
        theme: _propTypes2.default.oneOf(['theme-background-color-dark', 'theme-background-color-blue'])
      }),
      img: _propTypes2.default.shape({
        src: _propTypes2.default.string.isRequired,
        alt: _propTypes2.default.string.isRequired
      }),
      text: _propTypes2.default.string.isRequired
    })
  }),
  className: _propTypes2.default.string
};

OverlayHero.defaultProps = _default2.default;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/overlay-hero/jsx/OverlayHero.js
// module id = 1122
// module chunks = 4